import {FC, useRef} from 'react'
import {useQuery} from 'react-query'
import {useLocation, useNavigate} from 'react-router-dom'
import {TaskEditModalForm} from './TaskEditModalForm'
import {ID, QUERIES} from '../../../../../../_metronic/helpers'
import {getTaskById} from '../core/_requests'
import {Loading} from '../../../../../../_metronic/partials/components/loading/Loading'

type Props = {
  handleClose: () => void | undefined
  taskId: ID
  handleForceClose?: () => void | undefined
}

const TaskEditModalFormWrapper: FC<Props> = ({handleClose, taskId, handleForceClose}) => {
  const location = useLocation()
  const {pathname} = location
  const navigate = useNavigate()
  const didRedirectRef = useRef(false)

  const {
    isLoading,
    data: task,
    error,
  } = useQuery(
    `${QUERIES.TASKS_LIST}-task-${taskId}`,
    () => {
      return getTaskById(taskId)
    },
    {
      enabled: !!taskId,
      cacheTime: 0,
      refetchOnWindowFocus: true,
      onSuccess: (data) => {
        if (!data.tasks) {
          // Se a tarefa não vier válida (ex: inconsistência / outra instância),
          // fecha o modal limpando a search params.
          navigate(pathname, {replace: true})
        }
      },
      onError: () => {
        if (didRedirectRef.current) return
        didRedirectRef.current = true
        // Evita hard-reload e não preserva search (?mode=...&taskId=...)
        navigate('/404', {replace: true})
      },
      retry: false,
    }
  )

  if (!isLoading && !error) {
    return (
      <TaskEditModalForm
        isTaskLoading={isLoading}
        handleClose={handleClose}
        handleForceClose={handleForceClose}
        task={task!}
      />
    )
  } else {
    return <Loading />
  }
}

export {TaskEditModalFormWrapper}
